import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[currency]',
  standalone: true
})
export class CurrencyDirective {

  private readonly locale: string = 'pt-BR';
  private readonly currencySymbol: string = 'R$ ';
  private readonly fractionDigits: number = 2;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const numericValue = value
      .replace('.', '')
      .replace(',', '')
      .replace(/\D/g, '');

    const formattedValue = this.formatCurrency(numericValue);
    this.el.nativeElement.value = formattedValue;
  }

  private formatCurrency(value: string): string {
    const numeric = parseFloat(value) / 100;
    const options = { minimumFractionDigits: this.fractionDigits };
    const formatted = new Intl.NumberFormat(this.locale, options).format(numeric);

    return this.currencySymbol + formatted;
  }
}
